import firebase from 'firebase'

let config = {
    apiKey: "AIzaSyBlGwmNTfO131Cz5qIFTHVbHXvONYaGmhM",
    authDomain: "portfolio-8c0bd.firebaseapp.com",
    databaseURL: "https://portfolio-8c0bd.firebaseio.com",
    projectId: "portfolio-8c0bd",
    storageBucket: "portfolio-8c0bd.appspot.com",
    messagingSenderId: "207911203358",
    appId: "1:207911203358:web:580b1dcc9e118d2d"
};
// Initialize Firebase
let fire = firebase.initializeApp(config);
// export const provider = new firebase.auth.GoogleAuthProvider();
// export const auth = firebase.auth();
export default fire;